var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpportunityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1716 49.3438L48.5078 39.6799C46.3556 43.3163 43.316 46.3558 39.6797 48.5081L49.3435 58.1719C50.5212 59.3516 52.0896 60 53.7576 60C55.4236 60 56.9919 59.3516 58.1716 58.1719C60.6052 55.7363 60.6052 51.7754 58.1716 49.3438Z",
    fill: "#F48000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 27C50 14.3184 39.6816 4 27 4C14.3184 4 4 14.3184 4 27C4 39.6816 14.3184 50 27 50C39.6816 50 50 39.6816 50 27ZM27 46C16.5234 46 8 37.4766 8 27C8 16.5234 16.5234 8 27 8C37.4766 8 46 16.5234 46 27C46 37.4766 37.4766 46 27 46Z",
    fill: "#F48000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10C17.6112 10 10 17.6111 10 27C10 36.3888 17.6112 44 27 44C36.3888 44 44 36.3888 44 27C44 17.6111 36.3888 10 27 10ZM28.4407 37.1367C28.1125 37.6777 27.5742 38 27 38C26.4258 38 25.8875 37.6777 25.5593 37.1367C24.6313 35.6016 20 27.748 20 24C20 19.5879 23.1394 16 27 16C30.8606 16 34 19.5879 34 24C34 27.748 29.3687 35.6016 28.4407 37.1367Z",
    fill: "#F48000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 26C28.6569 26 30 24.6569 30 23C30 21.3431 28.6569 20 27 20C25.3431 20 24 21.3431 24 23C24 24.6569 25.3431 26 27 26Z",
    fill: "#F48000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunityIcon);
export default __webpack_public_path__ + "static/media/opportunity_icon.7800cafb652b3fee8aabd8c9c63202aa.svg";
export { ForwardRef as ReactComponent };